module.exports = "<div *ngIf=\"loading\" class=\"app-loading\"></div>\r\n<router-outlet></router-outlet>\r\n"